import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import { BaseUrl } from "../../helper/BaseUrl";
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import axios from "axios";

const truncateText = (htmlString, maxLength) => {
    if (!htmlString || typeof htmlString !== "string") return "";
    const plainText = htmlString.replace(/<\/?[^>]+(>|$)/g, "");
    return plainText.length > maxLength ? plainText.substring(0, maxLength) + "..." : plainText;
};

export default function BlogDetail({initialData}) {
    const navigate = useNavigate();
    const {blog_slug} = useParams();
    const [data, setData] = useState(initialData || []);
    const [allBlog, setAllBlog] = useState([]);

    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get(`${BaseUrl}/api/blog/${blog_slug}`);
          setData(response.data?.data);
          if(response.error){
            navigate("/404")
          }
        } catch (error) {
            navigate("/404")
          console.error("Error fetching blog data:", error);
        }
      };
  
      fetchData();
    }, [blog_slug]);


    const convertDate = (dateString) => {
        const date = new Date(dateString);
        const months = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = months[date.getMonth()];
        const day = date.getDate();
        const year = date.getFullYear();
        return `${month} ${day}, ${year}`;
    };

  return (
    <>
    <section className="blogdetail">
        <div className="container">
            <div className="row justify-content-center">

                <div className="col-lg-10 col-md-10">
                    <div className='blogdetail-head'>
                        <span>{convertDate(data?.created_at)}</span>
                        <h1 className="heading gradient-color">{data?.title}</h1>
                        <p>Written By {data?.author_name}</p>
                    </div>

                    <div className='blogdetail-content'>
                        <img src={`${BaseUrl}${ data?.image1 }`} className="img-responsive mt-0" alt="blog"/>

                        {data?.shortdescription && <p dangerouslySetInnerHTML={{ __html: data.shortdescription }} />}

                        {data?.first_description && <div dangerouslySetInnerHTML={{ __html: data.first_description }} />}


                        <img src={`${BaseUrl}${ data?.image2 }`} className="img-responsive" alt="blog" loading="lazy"/>

                        {data?.second_description && <div dangerouslySetInnerHTML={{ __html: data.second_description }} />}


                        <img src={`${BaseUrl}${ data?.image3 }`} className="img-responsive" alt="blog" loading="lazy"/>

                        {data?.third_description && <div dangerouslySetInnerHTML={{ __html: data.third_description }} />}


                        <img src={`${BaseUrl}${ data?.image4 }`} className="img-responsive" alt="blog" loading="lazy"/>

                        {data?.fourth_description && <div dangerouslySetInnerHTML={{ __html: data.fourth_description }} />}


                        <div className="blogdetail-social">
                            <Link to={"https://www.facebook.com/profile.php?id=61561567174333"} target="_blank" aria-label="Facebook"><Icons name="facebook"/></Link>
                            <Link to={"https://www.instagram.com/sonamslabel"} target="_blank" aria-label="instagram"><Icons name="instagram"/></Link>
                            <Link to={"https://www.pinterest.com/sonamlabel"} target="_blank" aria-label="pinterest"><Icons name="pinterest"/></Link>
                            <Link to={"https://www.youtube.com/@SonamLabel"} target="_blank" aria-label="youtube"><Icons name="youtube"/></Link>
                        </div>
                    </div>

                    <div className='blog-nextprev'>
                        {data?.previous_blog && (
                        <Link to={`/blog/${data.previous_blog.slug}`} className='nextprev-box'>
                            <img src={`${BaseUrl}${data.previous_blog.listing_image}`} alt={data.previous_blog.alt} loading="lazy"/>
                            <div>
                                <h5>{truncateText(data.previous_blog.title, 30)}</h5>
                                <p>{truncateText(data.previous_blog.shortdescription, 65)}</p>
                                <span className='gradient-color'>Previous Post</span>
                            </div>
                        </Link>
                        )}

                        {data?.next_blog && (
                        <Link to={`/blog/${data.next_blog.slug}`} className='nextprev-box'>
                            <img src={`${BaseUrl}${data.next_blog.listing_image}`} alt={data.next_blog.alt} loading="lazy"/>
                            <div>
                                <h5>{truncateText(data.next_blog.title, 30)}</h5>
                                <p>{truncateText(data.next_blog.shortdescription, 65)}</p>
                                <span className='gradient-color'>Next Post</span>
                            </div>
                        </Link>
                        )}
                    </div>
                </div> 

                {/* <div className="col-lg-10 col-md-10">
                    <div className='blogdetail-head'>
                        <span>7 Days Ago</span>
                        <h1 className="heading gradient-color">Top Bridal Lehenga Trends for 2025</h1>
                        <p>Written By Sonam’s Label</p>
                    </div>

                    <div className='blogdetail-content'>
                        <img src="/image/blogdetail-1.webp" className="img-responsive mt-0" alt="blog"/>

                        <p>The wedding season of 2025 is bringing with it a fresh wave of bridal fashion that beautifully blends tradition with modernity. For brides who are dreaming of the perfect lehenga that turns heads and stays timeless in photos for decades to come, this year’s trends offer a delightful mix of elegance, innovation, and cultural richness.</p>

                        <p>From unexpected color palettes to sustainable designs and high-drama silhouettes, here are the top bridal lehenga trends you’ll see dominating mandaps, Pinterest boards, and Instagram feeds in 2025.</p>

                        <h2>Beyond Red: The Rise of Unconventional Bridal Colors</h2>

                        <p>While red remains a beloved classic, 2025 is all about embracing unique hues that reflect a bride’s individuality and modern spirit. Think ethereal powder blues, refreshing sage greens, dreamy lavenders, bold burnt oranges, and the understated elegance of champagne gold. These unconventional shades are redefining bridal fashion, allowing every bride to express her personality through color.</p>

                        <p>These colors are ideal for brides looking to break away from tradition without compromising on elegance. Designers are now offering softer tones with intricate hand embroidery, perfect for both daytime and destination weddings.</p>

                        <img src="/image/blogdetail-2.webp" className="img-responsive" alt="blog" loading="lazy"/>

                        <h3>Heavy Embroidery, Lightweight Fabrics</h3>

                        <p>In 2025, brides are seeking the best of both worlds - the timeless allure of opulent embroidery paired with the ease of effortless comfort. This evolving preference is driving a noticeable shift toward lighter, breathable fabrics like georgette, crepe, and organza. These airy textiles are being exquisitely adorned with intricate zardozi, shimmering gota patti, delicate threadwork, and playful mirror embellishments, creating ensembles that are as graceful to wear as they are stunning to behold.</p>

                        <h4>Sustainability in Bridal Wear</h4>

                        <p>Eco-conscious brides are on the rise, and so is the influence of sustainable fashion. In 2025, this shift isn’t just a fleeting trend it’s a powerful movement reshaping the bridal industry. Today’s brides are prioritizing mindful choices, seeking outfits that align with their values without compromising on beauty. In response, more designers are embracing eco-friendly practices incorporating organic fabrics like handwoven cotton and bamboo silk, natural plant-based dyes, and upcycled embellishments such as vintage borders and repurposed embroidery. The result? Bridal lehengas that are not only breathtakingly beautiful but also ethically crafted and gentle on the planet.</p>

                        <p>From handwoven khadi to ethically sourced silks and organic cottons, today’s bridal wear is being thoughtfully crafted with a significantly lower carbon footprint and minimal waste. Designers are focusing on slow fashion principles, supporting local artisans, and embracing eco-conscious techniques that celebrate both heritage and sustainability. The result is bridal attire that not only looks exquisite but also tells a meaningful story of responsibility and respect for the environment.</p>

                        <img src="/image/blogdetail-3.webp" className="img-responsive" alt="blog" loading="lazy"/>

                        <h4>Sheer Drama: Capes, Veils & Trails</h4>

                        <p>If there’s one word that defines bridal fashion in 2025, it’s drama and not the emotional kind! This year, brides are boldly stepping into the spotlight with statement-making silhouettes that exude grandeur and flair. Think floor-sweeping veils that trail like poetry, sheer embellished capes that add a touch of mystique, and exaggerated lehenga trails that command attention with every step. Voluminous skirts, sculpted blouses, and structured drapes are taking center stage, allowing modern brides to channel their inner diva while staying rooted in tradition. It’s all about making an unforgettable entrance and leaving a lasting impression.</p>

                        <p>These elements add a layer of grandeur, making the bride look ethereal and goddess-like, especially during the bridal entry or pheras.</p>

                        <h4>Statement Blouses: The New Hero Piece</h4>

                        <p>The blouse is no longer just an accessory to the lehenga - it’s becoming the ultimate statement piece in bridal fashion. In 2025, brides are pushing the boundaries of tradition and embracing bold, fashion-forward designs that let their personality shine. From structured corset-style blouses that sculpt the silhouette to dramatic balloon sleeves that add volume and flair, the blouse is taking center stage. 3D floral embellishments, intricate beadwork, mirror detailing, and off-shoulder or asymmetric cuts are redefining bridal elegance. Whether paired with a classic lehenga or a contemporary draped skirt, these standout blouses are giving brides the freedom to mix tradition with trend, creating looks that are both memorable and modern.</p>

                        <p>For the more adventurous, plunging necklines, backless styles, and structured silhouettes are also gaining popularity. These bold choices allow brides to express their individuality while adding a touch of contemporary glamour to traditional bridal wear.</p>

                        <img src="/image/blogdetail-4.webp" className="img-responsive" alt="blog" loading="lazy"/>

                        <h4>Final Thoughts</h4>

                        <p>2025 is shaping up to be a landmark year for bridal fashion a harmonious blend of creativity, comfort, culture, and couture. Designers are reimagining tradition with fresh eyes, offering silhouettes and styles that speak to the modern bride’s individuality while honoring timeless elegance. Whether you're a bride-to-be dreaming of a show-stopping, statement lehenga or leaning toward something classic, graceful, and rooted in heritage, this year's trends cater to every vision and vibe.</p>

                        <p>From bold colors and sustainable fabrics to intricate handwork and contemporary blouse cuts, the possibilities are endless. But amidst all the trends, remember the most powerful statement you can make is wearing something that makes you feel confident, radiant, and unapologetically you. Because your bridal lehenga isn’t just an outfit. it’s a memory in motion, a celebration of love, woven together with fabric, thread, emotion, and dreams.</p>

                        <div className="blogdetail-social">
                            <Link to={"https://www.facebook.com/profile.php?id=61561567174333"} target="_blank" aria-label="Facebook"><Icons name="facebook"/></Link>
                            <Link to={"https://www.instagram.com/sonamslabel"} target="_blank" aria-label="instagram"><Icons name="instagram"/></Link>
                            <Link to={"https://www.pinterest.com/sonamlabel"} target="_blank" aria-label="pinterest"><Icons name="pinterest"/></Link>
                            <Link to={"https://www.youtube.com/@SonamLabel"} target="_blank" aria-label="youtube"><Icons name="youtube"/></Link>
                        </div>
                    </div>

                    <div className='blog-nextprev'>
                        <Link className='nextprev-box'>
                            <img src="/image/blogpost-2.webp" alt="blog" loading="lazy"/>
                            <div>
                                <h5>How to Choose the Perfect Brid...</h5>
                                <p>Finding the perfect bridal lehenga is about choosing a silhouette that...</p>
                                <span className='gradient-color'>Previous Post</span>
                            </div>
                        </Link>
                    
                        <Link className='nextprev-box'>
                            <img src="/image/blogpost-3.webp" alt="blog" loading="lazy"/>
                            <div>
                                <h5>Bridal Lehenga vs Saree: Wha...</h5>
                                <p>Choosing between a lehenga and a saree comes down to style, com....</p>
                                <span className='gradient-color'>Next Post</span>
                            </div>
                        </Link>
                    </div>
                </div>  */}

            </div>
        </div>
    </section>
    </>
  )
}
